export function hasIntegration(
  integrations: Record<string, boolean> | undefined | null,
  name: string
): boolean {
  return Boolean(integrations && integrations[name] === true)
}

export function hasAnyIntegration(
  integrations: Record<string, boolean> | undefined | null
): boolean {
  return Boolean(integrations && Object.values(integrations).some(Boolean))
}
